import React from 'react';

function PrivacyPolicy() {
  return (
    <div className="max-w-4xl mx-auto p-6">
      <h1 className="text-3xl font-bold mb-6 text-gray-800">Privacy Policy</h1>
      <p className="text-gray-600 mb-8">Last updated: 30 April 2025</p>

      <section className="mb-8 bg-white p-6 rounded-lg shadow-md border border-gray-100">
        <h2 className="text-2xl font-semibold mb-4 text-gray-800">1. Who we are</h2>
        <p className="mb-4 text-gray-600">
          "Elevate Sports Center" ("the App") is operated by Elevate Sports Center, located at Saudi Arabia, Riyadh. 
          You can reach us at millerzbusiness@gmail.com.
        </p>
      </section>

      <section className="mb-8 bg-white p-6 rounded-lg shadow-md border border-gray-100">
        <h2 className="text-2xl font-semibold mb-4 text-gray-800">2. What data we collect</h2>
        <p className="mb-4 text-gray-600">
          This early internal-testing version does not collect, store, or transmit any personal data.
        </p>
        <ul className="list-disc pl-6 mb-4 text-gray-600">
          <li>No account information is stored on our servers.</li>
          <li>No usage analytics or crash logs are sent.</li>
          <li>No location, contact, payment, health, or sensitive data is processed.</li>
        </ul>
      </section>

      <section className="mb-8 bg-white p-6 rounded-lg shadow-md border border-gray-100">
        <h2 className="text-2xl font-semibold mb-4 text-gray-800">3. Permissions</h2>
        <p className="mb-4 text-gray-600">
          The App requests only the permissions necessary to:
        </p>
        <ul className="list-disc pl-6 mb-4 text-gray-600">
          <li>connect to the internet (for future booking features).</li>
        </ul>
        <p className="text-gray-600">All other Android and iOS permissions remain disabled in this build.</p>
      </section>

      <section className="mb-8 bg-white p-6 rounded-lg shadow-md border border-gray-100">
        <h2 className="text-2xl font-semibold mb-4 text-gray-800">4. How we use data in future releases</h2>
        <p className="text-gray-600">
          When the full feature set (court bookings, payments, retail shop, etc.) goes live, we may need to process limited personal information (e.g., email for sign-in, card details for payments). We will update this policy before any such data collection begins.
        </p>
      </section>

      <section className="mb-8 bg-white p-6 rounded-lg shadow-md border border-gray-100">
        <h2 className="text-2xl font-semibold mb-4 text-gray-800">5. Data sharing</h2>
        <p className="mb-4 text-gray-600">
          Because we collect no data in this build, we share no data with third parties. In production, payment data will be processed securely by Stripe, Apple Pay, and Google Pay under their respective privacy policies.
        </p>
      </section>

      <section className="mb-8 bg-white p-6 rounded-lg shadow-md border border-gray-100">
        <h2 className="text-2xl font-semibold mb-4 text-gray-800">6. Security</h2>
        <p className="mb-4 text-gray-600">
          The App communicates only over encrypted (HTTPS/TLS) connections.
          No user credentials or payment details are stored on the device or our servers in this version.
        </p>
      </section>

      <section className="mb-8 bg-white p-6 rounded-lg shadow-md border border-gray-100">
        <h2 className="text-2xl font-semibold mb-4 text-gray-800">7. Children's privacy</h2>
        <p className="text-gray-600">
          The App is intended for users aged 18 and over. We do not knowingly collect information from children.
        </p>
      </section>

      <section className="mb-8 bg-white p-6 rounded-lg shadow-md border border-gray-100">
        <h2 className="text-2xl font-semibold mb-4 text-gray-800">8. Changes to this policy</h2>
        <p className="text-gray-600">
          We may revise this policy to reflect future functionality. We will post the updated version in-app and on our website, and change the "Last updated" date accordingly.
        </p>
      </section>

      <section className="mb-8 bg-white p-6 rounded-lg shadow-md border border-gray-100">
        <h2 className="text-2xl font-semibold mb-4 text-gray-800">9. Contact us</h2>
        <p className="text-gray-600">
          If you have questions about this Privacy Policy, email millerzbusiness@gmail.com.
        </p>
      </section>
    </div>
  );
}

export default PrivacyPolicy; 